import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { recordPageView } from 'src/analytics/amplify';
import { kinesisAnalyticsEnabled } from 'src/constants/feature-gates';

/**
 * Replaces `Analytics.autoTrack('pageView')`, which reaches the Pinpoint provider only. Renders
 * inside BrowserRouter because it reads the router's location.
 *
 * Emits on mount as well as on navigation, because Amplify's PageViewTracker fires once when it
 * installs its history patches. Raw `history.pushState` calls are not covered, so the accordion
 * navigation in useHashExpander no longer emits.
 */
function PageViewEmitter(): null {
    const location = useLocation();
    const lastKey = useRef<string | null>(null);

    useEffect(() => {
        // StrictMode runs the effect twice for one location.
        if (!kinesisAnalyticsEnabled() || lastKey.current === location.key) {
            return;
        }
        lastKey.current = location.key;

        recordPageView({
            url: window.location.href,
            referrer: document.referrer,
        });
    }, [location.key]);

    return null;
}

export default PageViewEmitter;
